// extracted by mini-css-extract-plugin
export default {"payment":"styles_payment__uJuym","payment__col":"styles_payment__col__z0oss"};